<div
  *ngIf="isLoading"
  class="h-[700px] w-full flex items-center justify-center"
>
  <app-loading></app-loading>
</div>
<div
  *ngIf="!isLoading && company"
  class="w-full flex flex-col items-center pb-20 pt-5"
>
  <div
    class="w-11/12 md:w-4/5 mx-auto relative rounded-2xl overflow-hidden shadow-lg"
  >
    <img
      [src]="companyBanner"
      [alt]="company.commercialName"
      class="w-full h-36 sm:h-44 md:h-48 object-cover"
    />
  </div>
  <div
    class="w-full md:w-4/5 mx-auto relative -mt-8 sm:-mt-10 flex flex-col sm:flex-row justify-between items-start sm:items-end px-4 sm:px-6 gap-4"
  >
    <div class="flex items-end gap-4 flex-wrap sm:flex-nowrap">
      <div
        class="w-24 h-24 sm:w-28 sm:h-28 rounded-xl shadow-lg overflow-hidden border-4 border-white bg-white shrink-0"
      >
        <img
          [src]="companyImage"
          [alt]="company.commercialName"
          class="w-full h-full object-contain"
        />
      </div>
      <div class="flex flex-col">
        <h1 class="text-xl sm:text-2xl font-bold text-gray-800">
          {{ company.commercialName }}
        </h1>
        <p class="text-gray-500 italic text-sm mt-1">
          "{{ company.slogan || "Innovando contigo" }}"
        </p>
      </div>
    </div>
    <div class="sm:mt-0 mt-2">
      <div
        *ngIf="isVerified(company); else notVerified"
        class="flex items-center text-green-600 bg-green-100 rounded-full px-3 py-1 text-sm font-medium"
      >
        <ng-icon name="heroCheckBadge" size="18"></ng-icon>
        <span class="ml-2">Verificado</span>
      </div>
      <ng-template #notVerified>
        <div
          class="flex items-center text-yellow-600 bg-yellow-100 rounded-full px-3 py-1 text-sm font-medium"
        >
          <ng-icon name="heroInformationCircle" size="18"></ng-icon>
          <span class="ml-2">No verificado</span>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="w-4/5 mt-6 flex gap-8">
    <button
      (click)="selectedTab = 'about'"
      [ngClass]="
        selectedTab === 'about'
          ? 'border-b-2 border-primary text-primary'
          : 'text-gray-500 hover:text-primary'
      "
      class="pb-2 font-medium cursor-pointer"
    >
      Sobre la empresa
    </button>
    <button
      (click)="selectedTab = 'jobs'; loadJobs()"
      [ngClass]="
        selectedTab === 'jobs'
          ? 'border-b-2 border-primary text-primary'
          : 'text-gray-500 hover:text-primary'
      "
      class="pb-2 font-medium cursor-pointer"
    >
      Ofertas de empleo
    </button>
  </div>
  <div
    *ngIf="selectedTab === 'about'"
    class="w-full mt-6 grid grid-cols-1 lg:grid-cols-3 gap-8 px-4 sm:px-8 md:px-16 lg:px-24 xl:px-36"
  >
    <div class="flex flex-col lg:order-2">
      @if(company.urlBannerOurHistory){
      <div class="w-full mb-6 order-2 lg:order-1">
        <img
          [src]="company.urlBannerOurHistory"
          alt="Banner"
          class="w-full h-48 sm:h-56 md:h-64 lg:h-72 rounded-sm mt-5 shadow-md object-cover"
        />
      </div>
      }
      <div class="bg-gray-100 p-5 rounded-xl space-y-4 order-1 lg:order-2">
        <div
          *ngIf="company.email"
          class="flex items-start gap-3 wrap-break-words"
        >
          <div
            class="bg-gray-200 flex items-center justify-center p-2 rounded-md shrink-0"
          >
            <ng-icon name="heroEnvelope" size="20" color="gray"></ng-icon>
          </div>
          <div class="flex-1">
            <p class="text-xs text-gray-500">Email</p>
            <span
              class="text-sm font-medium text-gray-800 wrap-break-words block"
            >
              {{ company.email }}
            </span>
          </div>
        </div>
        <div *ngIf="company.businessLine" class="flex items-start gap-3">
          <div
            class="bg-gray-200 flex items-center justify-center p-2 rounded-md shrink-0"
          >
            <ng-icon name="heroBriefcase" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-xs text-gray-500">Línea de negocio</p>
            <span class="text-sm font-medium">{{ company.businessLine }}</span>
          </div>
        </div>
        <div *ngIf="company.address" class="flex items-start gap-3">
          <div
            class="bg-gray-200 flex items-center justify-center p-2 rounded-md shrink-0"
          >
            <ng-icon name="heroMapPin" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-xs text-gray-500">Dirección</p>
            <span class="text-sm font-medium wrap-break-words block">
              {{ company.address }}
            </span>
          </div>
        </div>
        <div
          *ngIf="
            company.district ||
            company.province ||
            company.departament ||
            company.country
          "
          class="flex items-start gap-3"
        >
          <div
            class="bg-gray-200 flex items-center justify-center p-2 rounded-md shrink-0"
          >
            <ng-icon name="heroGlobeAlt" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-xs text-gray-500">Ubicación</p>
            <span class="text-sm font-medium wrap-break-words block">
              {{ company.district }}, {{ company.province }},
              {{ company.departament }}, {{ company.country }}
            </span>
          </div>
        </div>
        <div
          *ngIf="
            !company.email &&
            !company.businessLine &&
            !company.address &&
            !(
              company.district ||
              company.province ||
              company.departament ||
              company.country
            )
          "
          class="text-sm text-gray-500 italic text-center"
        >
          Esta compañía aún no ha registrado información de contacto ni
          ubicación.
        </div>
      </div>
    </div>
    <div
      class="md:col-span-2 space-y-6 order-2 lg:order-1 flex flex-col justify-start"
    >
      <div>
        <h2 class="text-lg font-semibold text-gray-800 mb-2">
          Información Comercial
        </h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{
            company.businessInformation ||
              "Esta compañía aún no registra información comercial."
          }}
        </p>
      </div>
      <div>
        <h2 class="text-lg font-semibold text-gray-800 mb-2">Misión</h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{ company.mission || "Esta compañía aún no ha definido su misión." }}
        </p>
      </div>
      <div>
        <h2 class="text-lg font-semibold text-gray-800 mb-2">Visión</h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{ company.vision || "Esta compañía aún no ha definido su visión." }}
        </p>
      </div>
      <div>
        <h2 class="text-lg font-semibold text-gray-800 mb-2">
          Nuestra Historia
        </h2>
        <p class="text-sm text-gray-600 leading-relaxed">
          {{
            company.ourHistory ||
              "Esta compañía aún no ha compartido su historia."
          }}
        </p>
      </div>
    </div>
  </div>
  <div *ngIf="selectedTab === 'jobs'" class="w-4/5 mt-6 min-h-[400px]">
    <app-loading *ngIf="isLoadingJobs"></app-loading>
    <div *ngIf="!isLoadingJobs">
      <ng-template
        [ngIf]="jobs.length === 0 && !isLoadingJobs"
        [ngIfElse]="jobList"
      >
        <div
          class="flex flex-col items-center justify-center text-gray-500 italic h-full p-10"
        >
          <p class="text-lg font-medium">
            Esta compañía no ha publicado ofertas de empleo.
          </p>
        </div>
      </ng-template>
      <ng-template #jobList>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div
            *ngFor="let job of jobs"
            class="rounded-2xl p-5 bg-white border border-gray-200 flex flex-col justify-between hover:border-primary hover:shadow-lg hover:shadow-sm-primary/20 transition-all duration-300"
          >
            <div>
              <h3 class="text-lg font-semibold text-gray-800 mb-1 line-clamp-3">
                {{ job.title }}
              </h3>
              <p class="text-sm text-gray-500 line-clamp-3">
                {{ job.subTitle }}
              </p>
            </div>
            <div class="mt-3">
              @if (job.publicationStatus === 'Finalizado') {
              <span
                class="bg-red-100 text-red-600 text-xs font-semibold px-3 py-1 rounded-full shadow-sm"
              >
                Oferta de empleo finalizada
              </span>
              }
            </div>
            <div class="mt-4 text-sm text-gray-500 space-y-1">
              <p>
                <span class="font-semibold">Fecha de publicación:</span>
                {{ job.publicationDate | date : "mediumDate" }}
              </p>
              <p>
                <span class="font-semibold">Salario:</span>
                {{ displaySalary(job) }}
              </p>
            </div>
            <div class="mt-6">
              <button
                class="w-full bg-primary hover:bg-primary/90 text-white text-sm font-semibold py-2 px-4 rounded-xl transition-colors"
                (click)="displayOffer(job.idJobOffer)"
              >
                Ver oferta de empleo
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
